module.exports = __webpack_public_path__ + "static/media/ginny-snooze.e16b8a8b.webp";